// extracted by mini-css-extract-plugin
export default {"indicator":"sliderJJSKEA","indicator--active":"sliderwuL6BE"};